import React from 'react';
import { Role } from '../../../types/permissions';
import { roleUtils } from '../../../utils/permissions';

interface RoleItemProps {
  role: Role;
  onDelete: (roleId: number) => void;
}

const RoleItem: React.FC<RoleItemProps> = ({ role, onDelete }) => {
  const canDelete = !roleUtils.isAdminRole(role.name);

  return (
    <div className="flex justify-between items-center p-3 border rounded-lg hover:bg-gray-50">
      <div className="flex-1">
        <div className="font-medium text-gray-900">{role.name}</div>
        <div className="text-sm text-gray-500">{role.description}</div>
      </div>
      {canDelete && (
        <button
          onClick={() => onDelete(role.id)}
          className="ml-4 px-3 py-1 text-red-500 hover:text-red-700 hover:bg-red-50 rounded"
        >
          Eliminar
        </button>
      )}
    </div>
  );
};

export default RoleItem;
